import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-reset-password-dialog",
  templateUrl: "./reset-password-dialog.component.html",
  styleUrls: ["./reset-password-dialog.component.scss"],
})
export class ResetPasswordDialogComponent {
  public code?: string;

  constructor(
    public dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { code?: string }
  ) {
    this.code = data?.code;
  }

  /**
   * Closes dialog when password reset succeeds
   */
  public resetPasswordFormSubmit(): void {
    this.dialogRef.close();
  }

  /**
   * Closes dialog and returns to previous view
   */
  public backClick(): void {
    this.dialogRef.close();
  }
}
